import { render, staticRenderFns } from "./explore1.vue?vue&type=template&id=b066accc&scoped=true&"
import script from "./explore1.vue?vue&type=script&lang=js&"
export * from "./explore1.vue?vue&type=script&lang=js&"
import style0 from "./explore1.vue?vue&type=style&index=0&id=b066accc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b066accc",
  null
  
)

export default component.exports